import styled from 'styled-components/macro';
import { css } from 'styled-components';

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';
import { tabletLandscapeUp } from '../../../styled/settings/mediaqueries';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { desktopUp, mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, fullContainerBackgroundImage, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading5, heroDescription, linkButtonText },
} = mixins;

export const PageSection = styled.section`
  ${pageSection}
  color: ${(props) => props.fontColor ? color(props.fontColor) : color(`white`)};

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.backgroundColor) && css`
    background-color: ${color(props.backgroundColor)};
  `}
  /* stylelint-enable */

  @media ${tabletPortraitDown} {
    padding: 0;
  }

  &:after {
    clear: both;
  }
`;

export const Container = styled.div`
  ${pageSectionInner}
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media ${tabletPortraitDown} {
    padding: 0;
  }
`;

const containerHeight = css`
  height: auto;
`;

export const ContentContainer = styled.div`
  ${containerHeight}
  display: grid;

  grid-template-columns: 30fr 10fr 60fr;
  grid-template-rows: 10fr 80fr 10fr;

  @media ${tabletPortraitDown} {
    grid-template-rows: 100fr;
    grid-template-columns: 60fr 40fr;
  }

  @media ${tabletPortraitDown} {
    display: block;
  }

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.alignContent && props.alignContent === `right`) && css`
    grid-template-columns: 60fr 10fr 30fr;

    @media ${tabletPortraitDown} {
      grid-template-columns: 100fr;
    }
  `}
  /* stylelint-enable */
`;

export const ContentContentContainer = styled.div`
  background-color: ${color(`white`)};
  max-width: 100%;

  grid-column-start: 2;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 4;

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.alignContent && props.alignContent === `right`) && css`
    grid-column-start: 1;
    grid-column-end: 3;
  `}
  /* stylelint-enable */

  @media ${tabletPortraitDown} {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 1;
  }
`;

export const Image = styled.div`
  z-index: 2;
  ${fullContainerBackgroundImage}
  min-height: 100%;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 3;

  img {
    position: relative;
    margin-top: 0;
    right: ${spacingsize(9)};
    top: ${spacingsize(9)};
  }

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.backgroundColor) && css`
    background-color: ${color(props.backgroundColor)};
  `}

  ${(props) => (props.alignContent && props.alignContent === `right`) && css`
    grid-column-start: 2;
    grid-column-end: 4;
    grid-row-start: 2;
    grid-row-end: 3;

    @media ${tabletPortraitDown} {
      grid-column-start: 1;
      grid-column-end: 1;
      grid-row-start: 2;
      grid-row-end: 2;
    }
  `}
  /* stylelint-enable */

  @media ${tabletPortraitDown} {
    height: 384px;

    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 1;
  }

  @media ${mobileDown} {
    height: 256px;
  }
`;

export const ContentContentInnerContainer = styled.div`
  height: 100%;
  display: block;
  padding: ${spacingsize(10)};
  background-color: ${`white`};

  @media ${desktopUp} {
    padding: ${spacingsize(12)}
  }
`;

export const ContentText = styled.div`
  width: 80%;
  margin-left: 20%;

  @media ${tabletPortraitDown} {
    width: 100%;
    margin-left: 0;
  }

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.alignContent && props.alignContent === `right`) && css`
    margin-left: 0%;
    margin-right: 20%
  `}
  /* stylelint-enable */
`;

export const Title = styled.h1`
  ${heading2}
  text-transform: uppercase;
`;

export const Subtitle = styled.h3`
  ${heading5}
  text-transform: uppercase;
  margin-top: ${spacingsize(7)};
`;

export const Description = styled.p`
  ${heroDescription}
  margin-top: ${spacingsize(11)};

  @media ${tabletPortraitDown} {
    margin-top: ${spacingsize(9)};
  }

  @media ${mobileDown} {
    margin-top: ${spacingsize(7)};
  }
`;

export const CtaLink = styled.a`
  ${linkButtonText}
  margin-top: ${spacingsize(13)};
`;

export const ContentContentClearfix = styled.div`
  clear: both;
`;